/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const expandablePaperStyle = {
  paper: {
    padding: "1rem",
    height: "100%",
  },
  heading: {
    fontSize: "1.5rem",
  },
};

export default expandablePaperStyle;
